import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { CiMenuKebab } from "react-icons/ci";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {
  MdOutlineStickyNote2,
  MdLabelImportantOutline,
  MdHistory,
  MdEditCalendar,
  MdDownload,
} from "react-icons/md";
import { TbFileInvoice } from "react-icons/tb";
import Tooltip from "../../../../../Components/Tooltip/Tooltip";
import { printMultipleFiles } from "./printMultipleFiles";
import { useTranslation } from "react-i18next";

export default function CustomMenu({
  row,
  setdetailModal,
  setProdHistoryModal,
  setInvoiceModal,
  handleOrderShipemnt,
  printLabel,
  printDeclaration,
  labelDownloading,
  CircularProgress,
  // Only the ⋮ button: Label and Decl live in the Shipping column; the menu
  // is unchanged and still has them.
  compact = false,
}) {
  const { t } = useTranslation("warehouse");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="table_action__wrap">
      {compact ? (
        <button
          type="button"
          onClick={handleClick}
          aria-haspopup="menu"
          aria-expanded={open}
          aria-label={t("orders.moreActionsFor", { id: row?.id })}
          title={t("orders.moreActions")}
          className="flex h-[26px] w-[26px] items-center justify-center rounded-md border-[1px] border-ui-border bg-ui-surface text-ui-text-muted transition-colors hover:border-brand hover:text-brand"
        >
          <CiMenuKebab size={14} />
        </button>
      ) : (
        <>
          <Tooltip title={t("orders.downloadShippingLabel")}>
            <div
              onClick={() =>
                row?.manual_shipment?.shipping_labels?.length > 0
                  ? printMultipleFiles(
                      row?.manual_shipment?.shipping_labels,
                      row?.manual_shipment?.shipment_tracking_id,
                    )
                  : printLabel(row)
              }
              className={`table_action__btn ${
                (row?.shipment &&
                  row?.shipment?.shipment_status?.toLowerCase() !==
                    "cancelled") ||
                row?.manual_shipment?.shipping_labels?.length > 0
                  ? ""
                  : "table_action__btn__disabled"
              }`}
            >
              <MdDownload size={10} />
              {t("orders.label")}
            </div>
          </Tooltip>
          <Tooltip title={t("orders.downloadShipmentDeclaration")}>
            <div
              onClick={() =>
                row?.manual_shipment?.shipping_declarations?.length > 0
                  ? printMultipleFiles(
                      row?.manual_shipment?.shipping_declarations,
                      row?.manual_shipment?.shipment_tracking_id,
                    )
                  : printDeclaration(row)
              }
              className={`table_action__btn ${
                (row?.shipment &&
                  row?.shipment?.shipment_status?.toLowerCase() !==
                    "cancelled" &&
                  row?.shipment?.single_shipping_invoice) ||
                row?.manual_shipment?.shipping_declarations?.length > 0
                  ? ""
                  : "table_action__btn__disabled"
              }`}
            >
              <MdDownload size={10} />
              {t("orders.decl")}
            </div>
          </Tooltip>
          <div className="table_action__btn" onClick={handleClick}>
            <CiMenuKebab size={10} style={{ marginRight: "2px" }} />
            {t("orders.more")}
          </div>
        </>
      )}
      <Menu
        id={`basic-menu-${row.id}`}
        anchorEl={anchorEl}
        open={open}
        size="small"
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": `basic-button-${row.id}`,
          "box-shadow": "none",
        }}
      >
        {row?.shipment &&
          row?.shipment?.shipment_status?.toLowerCase() !== "cancelled" && [
            <MenuItem
              className="boltTable__action_more_btn_label"
              key="invoice"
              onClick={() => {
                setInvoiceModal(row?.shipment?.id);
                handleClose();
              }}
            >
              <ListItemIcon>
                <MdOutlineStickyNote2 size={15} />
              </ListItemIcon>
              <ListItemText>{t("orders.viewShipment")}</ListItemText>
            </MenuItem>,
            <MenuItem
              className="boltTable__action_more_btn_label"
              key="label"
              onClick={() => {
                printLabel(row);
                handleClose();
              }}
            >
              <ListItemIcon>
                {labelDownloading === "label" + row?.id ? (
                  <CircularProgress size={15} color="grey" />
                ) : (
                  <>
                    <MdLabelImportantOutline size={15} />
                  </>
                )}
              </ListItemIcon>
              <ListItemText>{t("orders.label")}</ListItemText>
            </MenuItem>,
            row?.shipment?.single_shipping_invoice && (
              <MenuItem
                className="boltTable__action_more_btn_label"
                key="declaration"
                onClick={() => {
                  printDeclaration(row);
                  handleClose();
                }}
              >
                <ListItemIcon>
                  {labelDownloading === "Declaration" + row?.id ? (
                    <CircularProgress size={15} />
                  ) : (
                    <>
                      <TbFileInvoice size={15} />
                    </>
                  )}
                </ListItemIcon>
                <ListItemText>{t("orders.declaration")}</ListItemText>
              </MenuItem>
            ),
          ]}
        {row?.manual_shipment?.shipping_labels?.length > 0 && [
          <MenuItem
            className="boltTable__action_more_btn_label"
            key="label"
            onClick={() => {
              printMultipleFiles(
                row?.manual_shipment?.shipping_labels,
                row?.manual_shipment?.shipment_tracking_id,
              );
              handleClose();
            }}
          >
            <ListItemIcon>
              <MdLabelImportantOutline size={15} />
            </ListItemIcon>
            <ListItemText>{t("orders.label")}</ListItemText>
          </MenuItem>,
        ]}
        {row?.manual_shipment?.shipping_declarations?.length > 0 && [
          <MenuItem
            className="boltTable__action_more_btn_label"
            key="declaration"
            onClick={() => {
              printMultipleFiles(
                row?.manual_shipment?.shipping_declarations,
                row?.manual_shipment?.shipment_tracking_id,
              );
              handleClose();
            }}
          >
            <ListItemIcon>
              <TbFileInvoice size={15} />
            </ListItemIcon>
            <ListItemText>{t("orders.declaration")}</ListItemText>
          </MenuItem>,
        ]}
        <MenuItem
          className="boltTable__action_more_btn_label"
          onClick={() => {
            setProdHistoryModal(row);
            handleClose();
          }}
        >
          <ListItemIcon>
            <MdHistory
              size={15}
              style={{
                headerColor: "var(--color-brand)",
                cursor: "pointer",
              }}
            />
          </ListItemIcon>
          <ListItemText>{t("orders.viewNotes")}</ListItemText>
        </MenuItem>
        <MenuItem
          className="boltTable__action_more_btn_label"
          onClick={() => {
            setdetailModal([row?.id, true]);
            handleClose();
          }}
        >
          <ListItemIcon>
            <MdEditCalendar size={15} />
          </ListItemIcon>
          <ListItemText>{t("orders.viewPackingList")}</ListItemText>
        </MenuItem>
        <MenuItem
          className="boltTable__action_more_btn_label"
          onClick={() => {
            setdetailModal([row?.id, false]);
            handleClose();
          }}
        >
          <ListItemIcon>
            <MdEditCalendar size={15} />
          </ListItemIcon>
          <ListItemText>{t("orders.viewOrder")}</ListItemText>
        </MenuItem>
        <MenuItem
          className="boltTable__action_more_btn_label"
          onClick={() => {
            // 4th slot opts DetailsModal into the redesigned OrderView.
            setdetailModal([row?.id, false, undefined, true]);
            handleClose();
          }}
        >
          <ListItemIcon>
            <MdEditCalendar size={15} />
          </ListItemIcon>
          <ListItemText>
            {t("orders.viewOrder")}
            <span
              className="ml-1.5 rounded bg-brand-light px-1 py-px font-semibold uppercase leading-none text-brand-text"
              style={{ fontSize: "7px" }}
            >
              {t("orders.beta")}
            </span>
          </ListItemText>
        </MenuItem>
      </Menu>
    </div>
  );
}
